<template>
  <DashboardTemplate :navMenu="true" class="custom-activity feedback">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">ผลการประเมินหลักสูตร</h2>
    </div>
    <div v-if="courseList.length > 0">
      <div class="pd-b-3 flex-display js-between change-display">
        <div class="text-left flex-display ai-center change-display">
          <p class="mg-less">เลือกหลักสูตร</p>
          <el-dropdown class="mg-l-4" trigger="click">
            <span class="el-dropdown-link course-box">
              <span class="message-over clamp1">{{
                getCourseLabel(course)
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="course-box-menu">
              <el-dropdown-item v-for="item in courseList" :key="item._id">
                <div
                  @click="course = item._id"
                  class="dropdown-text-over"
                  :title="item.name"
                >
                  {{ item.name }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            @click="selectCourse"
            type="primary"
            class="light mg-l-4 btn-show"
            round
            >แสดงผล</el-button
          >
        </div>
        <div class="flex-display js-end search-download">
          <el-form v-if="activeName == '2'" @submit.prevent.native @keyup.enter.native="search">
            <el-input
              placeholder="ค้นหารายชื่อ"
              prefix-icon="el-icon-search"
              class="search-input"
              @blur="showInputSearch = false,!searchText && showSearch?search():null"
              @keyup.enter.native="search"
              @clear="searchText = '',search()"
              :class="{ show: showInputSearch }"
              clearable
              ref="search"
              v-model="searchText"
            ></el-input>

            <el-button
              v-if="!showInputSearch"
              @click="openSearchInput"
              icon="el-icon-search"
              round
              class="pd-x-2 primary border-color-primary"
              >ค้นหา</el-button
            >
          </el-form>
        </div>
      </div>
      <div v-if="showSearch && activeName == '2'" class="text-left ">
        <p class="mg-y-less">
          <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
        </p>
      </div>
      <el-tabs v-model="activeName" class="mg-t-4">
    
        <el-tab-pane :label="`สรุปผลประเมินตามหลักสูตร(${scoreSumList.length>0?scoreSumList.length-1:0})`" name="1">
          <div v-loading="loading" class="pd-b-3">
             <FeedbackScoreSumList
              :scoreList="scoreSumList"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="`สรุปผลประเมินตามรายชื่อ(${assessments.length})`"
          name="2"
        >
          <div v-loading="loading" >
            <FeedbackScoreList
              :feedbackScoreListConst="assessments"
              :courseId="courseId"
            />
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>
    <div v-else class="text-center">
      <p class="color-gray pd-y-1">*** ไม่มีข้อมูลหลักสูตร ***</p>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import FeedbackScoreList from "@/components/feedback/FeedbackScoreList";
import FeedbackScoreSumList from "@/components/feedback/FeedbackScoreSumList";
import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";

export default {
  components: {
    DashboardTemplate,
    FeedbackScoreList,
    FeedbackScoreSumList
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      activeName: "1",
      course: "",
      searchText: "",
      showInputSearch: false,
      loading: true,
      assessments: [],
      showSearch:false,
      courseId:'',
      source:'',
      sourceSum:'',
      scoreSumList:[]
    };
  },
  mounted() {
    this.fetchCourseList();
    this.fetchAssessment();
    this.fetchAssessmentRate()
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      this.course = this.courseList.length > 0 ? this.courseList[0]._id : "";
      this.courseId = this.course
    },
    fetchAssessment() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page: 0,
        limit: 0,
      };

      if (this.source) {
        this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token


      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`result/assessment`, obj,{cancelToken})
        .then((res) => {
          if (res.data.success) {
            this.assessments = res.data.obj;
          } else {
            this.assessments = [];
          }
        })
        .catch((e) => {
          console.log("fetchAssessment error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchAssessmentRate() {
      if (this.sourceSum) {
        this.sourceSum.cancel()
      }

      this.sourceSum = CancelToken.source()
      const cancelToken = this.sourceSum.token


      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`assessment/rate/${this.courseId}`,{cancelToken})
        .then((res) => {
          if (res.data.success) {
            if (res.data.obj.length > 0) {
              res.data.obj.push({
                _id:'total',
                name:'คะแนนประเมินเฉลี่ยทั้งหลักสูตร',
                avg:res.data.avgAll,
                updatedAt:''
              })
            }

            this.scoreSumList = res.data.obj;
          } else {
            this.scoreSumList = [];
          }
        })
        .catch((e) => {
          console.log("fetchAssessmentRate error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    selectCourse() {
      this.loading = true;
      this.courseId = this.course
      this.fetchAssessment();
      this.fetchAssessmentRate()
    },
    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    search() {
      this.loading = true;
      this.page = 1
      this.fetchAssessment();
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
  },
};
</script>